// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import constants from "@store/constants";
import { GetShipmentsApiParameter } from "@store/Framework/Services/ShipmentService";
import { getShipmentsDataView } from "@store/Framework/Store/Greif/Data/Shipments/ShipmentsSelectors";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/UpdateDraftParameter";
import debounce from "lodash/debounce";
import { useCallback } from "react";

export const useShipmentHistoryState = () => {
    return useAppSelector(state => state.greif.pages.shipmentHistory);
};

export const useShipmentHistoryDataView = (parameter?: GetShipmentsApiParameter) => {
    return useAppSelector(state => {
        return getShipmentsDataView(state, parameter || state.greif.pages.shipmentHistory.parameter);
    });
};

export const useShipmentHistoryDebouncedUpdateDraftParameter = () => {
    const dispatch = useAppDispatch();

    return useCallback(
        debounce(
            (parameter: GetShipmentsApiParameter) => dispatch(updateDraftParameter(parameter)),
            constants.searchDebounceDelay,
        ),
        [],
    );
};
